import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useDynamicTranslations } from '../common/hooks/useTranslations';

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      infoIconStyle: {
        position: 'absolute',
        top: '-18px',
        right: '-16px',
        color: COLORS.appBlue,
      },
    })
);

const SurveyFormInfo = ({ label }) => {
  const classes = useStyles();

  return (
    <Tooltip title={label} placement={'top-end'} arrow leaveDelay={2000}>
      <InfoIcon
        className={classes.infoIconStyle}
        sx={{ width: '20px', height: '20px' }}
      />
    </Tooltip>
  );
};

export default SurveyFormInfo;
